import { getGraphQLClientInsights } from 'utilities/graphql';

import CtaClick from './ctaClick.graphql';
import DownloadClick from './downloadClick.graphql';

let client;

// TODO: use restful endpoints for tracking rather than graphql? or change client
export function trackCtaClick(videoId, sessionId) {
  sendMutation(CtaClick, { videoId, sessionId });
}

export function trackDownloadClick(videoId, sessionId) {
  sendMutation(DownloadClick, { videoId, sessionId });
}

function sendMutation(mutation, variables) {
  if (!client) {
    client = getGraphQLClientInsights();
  }

  client.mutate({
    mutation,
    variables,
  });
}
